var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings glow--black"},[_c('div',{staticClass:"settings__setting pointer",on:{"click":function($event){return _vm.$store.commit('MUTE_AUDIO', _vm.toggle)}}},[_vm._v(" "+_vm._s(_vm.muted ? "Unmute" : "Mute")+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }